import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Download, Link2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TeamShareCard, useTeamCardActions } from "@/components/TeamShareCard";
import { ShareButtons, teamShareText } from "@/components/ShareButtons";

export default function TeamCardPage() {
  const { sport, slug } = useParams();
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const ref = useRef(null);
  const { download, copy } = useTeamCardActions(ref, sport, slug);
  useEffect(() => { api.get(`/teams/${sport}/${slug}/card`).then((r) => setD(r.data)).catch(() => setErr("Team not found")); }, [sport, slug]);
  return (
    <main className="mx-auto flex max-w-3xl flex-col items-center px-4 py-12" data-testid="team-card-page">
      {err && <p className="text-red-400" data-testid="team-card-error">{err}</p>}
      {d && (
        <>
          <TeamShareCard d={d} innerRef={ref} />
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button data-testid="team-card-download-btn" onClick={download} className="btn-primary"><Download size={16} /> Download PNG</button>
            <button data-testid="team-card-copy-link-btn" onClick={copy} className="btn-ghost"><Link2 size={16} /> Copy link</button>
          </div>
          <div className="mt-3"><ShareButtons text={teamShareText(d)} url={`${window.location.origin}/t/${sport}/${slug}`} testPrefix="team-share" /></div>
          <div className="mt-10 text-center">
            <p className="text-sm text-slate-400">{user ? "See the full table, schedule, betting trends and the model's record on this team." : "The Parlay Lab grades every AI call against the table — follow teams, ride form and build parlays with real win probabilities."}</p>
            <Link to={user ? `/teams/${sport}/${slug}` : "/register"} data-testid="team-card-cta" className="btn-primary mt-4 inline-flex">{user ? "Open team page" : "Get today's picks free"}</Link>
          </div>
        </>
      )}
    </main>
  );
}
